import React from 'react';
import { useNavigate } from 'react-router-dom';

const serif = "'Georgia', 'Times New Roman', serif";

const PaywallModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div
      data-testid="paywall-modal"
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        backgroundColor: 'rgba(0,0,0,0.85)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 20,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          maxWidth: 420, width: '100%',
          border: '1px solid rgba(212,175,55,0.3)', borderRadius: 14,
          padding: '36px 28px', backgroundColor: '#0a0a0a',
          textAlign: 'center',
        }}
      >
        <div style={{
          width: 56, height: 56, borderRadius: '50%', margin: '0 auto 20px',
          backgroundColor: 'rgba(212,175,55,0.08)', border: '2px solid rgba(212,175,55,0.3)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.5">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          </svg>
        </div>

        <h2 style={{ fontFamily: serif, fontSize: 22, color: '#D4AF37', marginBottom: 12 }}>
          Votre Coffre-fort est plein
        </h2>

        <p style={{ fontFamily: serif, fontSize: 14, color: '#FAF3E0', lineHeight: 1.7, marginBottom: 24 }}>
          Vous avez atteint la limite de 50 Trésors. Pour protéger davantage de souvenirs, choisissez un Livre de Prestige avec plus de capacité.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 24 }}>
          {[
            { name: "L'Héritage", photos: 80, finish: 'Cuir', price: 79 },
            { name: 'Le Sanctuaire', photos: 200, finish: 'Soie', price: 129 },
          ].map(offer => (
            <button
              key={offer.name}
              data-testid={`paywall-${offer.name.toLowerCase().replace(/[' ]/g, '')}`}
              onClick={() => { onClose(); navigate('/offres'); }}
              style={{
                fontFamily: serif, fontSize: 14,
                padding: '14px 20px', borderRadius: 10, cursor: 'pointer',
                backgroundColor: 'transparent',
                color: '#D4AF37',
                border: '1px solid rgba(212,175,55,0.3)',
                transition: 'all 0.2s', textAlign: 'left',
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              }}
              onMouseEnter={e => { e.currentTarget.style.backgroundColor = 'rgba(212,175,55,0.06)'; e.currentTarget.style.borderColor = '#D4AF37'; }}
              onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.borderColor = 'rgba(212,175,55,0.3)'; }}
            >
              <span>{offer.name} — {offer.photos} Photos, {offer.finish}</span>
              <span style={{ fontWeight: 600 }}>{offer.price}€</span>
            </button>
          ))}
        </div>

        <button
          onClick={onClose}
          data-testid="paywall-close"
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 8, display: 'flex', justifyContent: 'center', width: '100%', marginTop: 4 }}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>
    </div>
  );
};

export default PaywallModal;
